//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import checkTokenBalance from "~/mixins/checkTokenBalance";

export default {
    name: 'ReviewJobModal',

    mixins: [checkTokenBalance],

    data() {
        return {
            showPublishJobModal: false,
            showScrollButton: true,
            showTokenPackageDialog: false
        };
    },

    computed: {
        ...mapGetters('jobs/single', {
            job: 'getSingleJob',
        }),

        detailsCompleted() {
            let required = !!this.job?.title && !!this.job?.job_type && !!this.job?.location_type && !!this.job?.start_date;
            let sometimes = this.job?.location_type !== 'Remote' ? !!this.job?.location_information : true;

            return required && sometimes;
        },

        industryCompleted() {
            return this.job?.industries.length > 0;
        },

        describeCompleted() {
            return (!!this.job?.description && this.job?.description.length > 0) || this.job?.documents.length > 0;
        },

        canPublish() {
            return this.detailsCompleted && this.industryCompleted && this.describeCompleted;
        },
        universities(){
          return this.job?.requirements.filter((i) => i.requirement_type === 'preferred_university');
        },
        experience(){
          return this.job?.requirements.filter((i) => i.requirement_type === 'experience');
        },
        education(){
          return this.job?.requirements.filter((i) => i.requirement_type === 'education');
        },
        transport(){
          return this.job?.requirements.filter((i) => i.requirement_type === 'transport');
        },
        skills(){
          return this.job?.requirements.filter((i) => i.requirement_type === 'skills');
        },
    },

    created() {
        this.getJob();
    },

    methods: {
        async getJob() {
            await this.$store.dispatch('jobs/draft/getJobPost', this.$route.params.id).then((res) => {
                this.$store.dispatch('jobs/single/updateJobPost', res);
            });
        },

        jobPublished() {
            this.$toast.show({
                type: 'success',
                message: 'Successfully published job post',
            });

            this.showPublishJobModal = false;

            this.$router.push(this.localePath({ name: 'jobs' }));
        },

        viewJob() {
            this.$router.push(this.localePath({ path: '/jobs/' + this.$route.params.id }));
            this.$emit('close-modal');
        },

        openDraft(step, hash) {
            this.$store.dispatch('jobs/draft/setCurrentStep', step);
            this.$router.push(`/jobs/draft/${this.$route.params.id}${hash ?? ''}`);
            this.$emit('close-modal');
        },

        handleScroll() {
            this.showScrollButton = this.$refs.modalContent.scrollHeight !== this.$refs.modalContent.clientHeight + this.$refs.modalContent.scrollTop;
        },

        scrollToBottom() {
            this.$refs.modalContent.scrollTo(0, this.$refs.modalContent.scrollHeight);
        },
    },
};
